<template>
  <v-container fluid>
    <div class="modal-padding">
      <v-row>
        <v-col cols="12" sm="12" class="left--right-00">
          <div class="add-que-modal-head">
            <div class="que-details">Question {{index+1}}:</div>
            <div
              class="que-details"
            >Subject: {{selectedQuestion.subject?selectedQuestion.subject.title:''}}</div>
            <div
              class="que-details"
            >Q.Type: {{selectedQuestion.questionType?selectedQuestion.questionType.title:''}}</div>
            <div class="que-details-1">
              <v-select v-model="slectedChapter" @change="onSelectChapter" :items="chapters" label="Chapter" hide-details dense outlined class="required"></v-select>
            </div>
            <div class="close-button">
              <v-icon @click="onClose({status:false})">mdi-close-circle</v-icon>
            </div>
             
          </div>
          <div
            v-if="qtype.ASSERTION_REASON===selectedQuestion.questionType.id||qtype.SINGLE_CORRECT===selectedQuestion.questionType.id"
            class="add-que-block-area"
          >
            <SingleAnsQue :showNextButton="showNextButton" :question="selectedQuestion" :onNextQuestion="onNextQuestion" />
          </div>
          <div
            v-else-if="qtype.MULTIPLE_CORRECT===selectedQuestion.questionType.id"
            class="add-que-block-area"
          >
            <MultipleCorrect :showNextButton="showNextButton" :question="selectedQuestion" :onNextQuestion="onNextQuestion" />
          </div>
          <div
            v-else-if="qtype.SUBJECTIVE===selectedQuestion.questionType.id || qtype.SUBJECTIVEINTEGER===selectedQuestion.questionType.id"
            class="add-que-block-area"
          >
            <Subjective :showNextButton="showNextButton" :question="selectedQuestion" :onNextQuestion="onNextQuestion" />
          </div>
          <div
            v-else-if="qtype.INTEGER===selectedQuestion.questionType.id"
            class="add-que-block-area"
          >
            <Integer :showNextButton="showNextButton" :question="selectedQuestion" :onNextQuestion="onNextQuestion" />
          </div>
          <div
            v-else-if="qtype.MATRIX_MATCH_OPTION===selectedQuestion.questionType.id"
            class="add-que-block-area"
          >
            <MatrixMatchOption :showNextButton="showNextButton" :question="selectedQuestion" :onNextQuestion="onNextQuestion" />
          </div>
          <div
            v-else-if="qtype.MATRIX_MATCH===selectedQuestion.questionType.id"
            class="add-que-block-area"
          >
            <MatrixMatch :showNextButton="showNextButton" :question="selectedQuestion" :onNextQuestion="onNextQuestion" />
          </div>
          <div
            v-else-if="qtype.COMPREHENSION===selectedQuestion.questionType.id"
            class="add-que-block-area"
          >
            <Comprehensions :showNextButton="showNextButton" :question="selectedQuestion" :onNextQuestion="onNextQuestion" />
          </div>
          <div
            v-else-if="qtype.TC===selectedQuestion.questionType.id"
            class="add-que-block-area"
          >
            <TC :showNextButton="showNextButton" :question="selectedQuestion" :onNextQuestion="onNextQuestion" />
          </div>
          <div class="right-align space-btn">
            <!-- <v-btn @click="onBackQuestion({})" class="right-btn cust-btn" color="primary">Add Next Question</v-btn>
            <v-btn @click="onNextQuestion({})" v-if="showNextButton" class="right-btn cust-btn" color="primary">Add Next Question</v-btn>-->
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import SingleAnsQue from "@/components/QuestionType/SingleAnsQue.vue";
import MultipleCorrect from "@/components/QuestionType/MultipleCorrect.vue";
import Subjective from "@/components/QuestionType/Subjective.vue";
import Integer from "@/components/QuestionType/Integer.vue";
import MatrixMatchOption from "@/components/QuestionType/MatrixMatchOption.vue";
import MatrixMatch from "@/components/QuestionType/MatrixMatch.vue";
import Comprehensions from "@/components/QuestionType/Comprehensions.vue";
import TC from "@/components/QuestionType/TC.vue";
export default {
  name: "QuestionAdd",
  components: {
    SingleAnsQue,
    MultipleCorrect,
    Subjective,
    Integer,
    MatrixMatchOption,
    MatrixMatch,
    Comprehensions,
    TC
  },
  props: ["onClose", "status", "data"],
  mounted() {
    this.qtype = this.QUE_TYPES;
    if (this.questions && this.questions.length && this.questions[this.index]) {
      this.selectedQuestion = this.questions[this.index];
      this.selectedQuestion.btnText =
        this.questions.length > 1 ? "Add Next Question" : "Done";
        if(this.selectedQuestion)
        {
        this.getChapters(this.selectedQuestion.subject.id);
        }
    }
  },
  data() {
    return {
      selectedQuestion: {},
      qtype: this.QUE_TYPES,
      index: 0,
      showNextButton: true,
      chapters: [],
      slectedChapter:null,
      selectedSubjectId:null
    };
  },
  methods: {
    
      ...mapActions({          
            getDataTreeWithLevel: "utilStore/getDataTreeWithLevel",
            createTest: "testStore/createTest"
        }),
    onNextQuestion(data) {
      if (this.validation(this.selectedQuestion)) {
       
        if (this.index < this.questions.length - 1) {
          this.index = this.index + 1;
          this.selectedQuestion = this.questions[this.index];
          if (this.index === this.questions.length - 1) {
            this.selectedQuestion.btnText = "Done";
          } else {
            this.selectedQuestion.btnText = "Add Next Question";
          }
          this.selectedQuestion.chapterId=null;
          this.slectedChapter=null;
          this.getChapters(this.selectedQuestion.subject.id);
            
        } else {
          let stepOneData = this.data.stepOneData;
          let list = [];
          let forUpdate = false;

          this.questions.map(q => {
            let obj = {
              index: q.index,
              subIndex: q.subIndex,
              question_text: q.question_text,
              question_type: q.questionType.id,
              subtype: q.subtype,
              data_type_id: q.chapterId,
              correct_marks: q.correctMarkingSchema,
              negative_marks: q.inCorrectMarkingSchema,
              partial_marking: q.partialMarking,
              questions: q.questions,
              solution: q.solution,
              hints: this.getHintsForRequest(q.hints)
            };
            if (q.id) {
              obj.id = q.id;
              forUpdate = true;
            }

            if (
              q.questionType.id === this.qtype.INTEGER ||
              q.questionType.id === this.qtype.SUBJECTIVE ||
              q.questionType.id === this.qtype.SUBJECTIVEINTEGER
            ) {
              obj.correct_answer = q.correct_answer;
            } else {
              obj.correct_answer = "-";
            }
            if (
              q.questionType.id === this.qtype.ASSERTION_REASON ||
              q.questionType.id === this.qtype.MULTIPLE_CORRECT ||
              q.questionType.id === this.qtype.SINGLE_CORRECT
            ) {
              obj.options = q.options;
            } else if (q.questionType.id === this.qtype.MATRIX_MATCH) {
              obj.options = q.options_abc.concat(q.options_pqr);
            } else if (q.questionType.id === this.qtype.MATRIX_MATCH_OPTION) {
              obj.options = q.options
                .concat(q.options_abc)
                .concat(q.options_pqr);
            }

            list.push(obj);
          });

          let reqData = {
            list: list,
            target: stepOneData.selectedTarget,
            test_type: stepOneData.testType
              ? stepOneData.testType
              : this.TEST_TYPE.CUSTOM,
            duration: stepOneData.duration,
            test_name: stepOneData.testName,
            instructions: this.data.instructions || ''
          };
          if (forUpdate) {
            reqData.only_question = true;
          }
          if (stepOneData.testId) {
            reqData.id = stepOneData.testId;
          }

          this.createTest(reqData)
            .then(response => {
              this.loading = false;
              this.$toasted.success(`Success\n${response.msg}`, {
                icon: "check_circle"
              });
              if (forUpdate) {
                this.onClose({ status: false, reloadPreview: true });
              } else {
                this.$router.push({ name: "customized-tests" });
              }
            })
            .catch(err => {
              this.loading = false;
            });
        }
      }
    },
          onSelectChapter(e) {
            if(this.selectedQuestion)
              {
                  this.selectedQuestion.chapterId=e.chapter_id;
              }
        },
    getChapters(subjectId) {
           

            if (subjectId&&subjectId!==this.selectedSubjectId) {
              this.chapters=[];              
              this.selectedSubjectId=subjectId;

                let reqData = {
                    level: 3,
                    parent: subjectId
                };
                this.$root.showLoader = true;

                this.getDataTreeWithLevel(reqData)
                    .then(response => {
                        this.$root.showLoader = false;
                        this.chapters = response.map(x => {
                            let c = {};
                            c.text = x.title;
                            c.value = { chapter_id: x.id };
                            return c;
                        });
                        
                    })
                    .catch(err => {
                        this.$root.showLoader = false;
                    });
            }
        },
    onBackQuestion(data) {
      if (this.index > 0) {
        this.index = this.index - 1;
        this.selectedQuestion = this.questions[this.index];
        this.selectedQuestion.btnText = "Add Next Question";
      }
    }
  },
  computed: {
    ...mapState("questionStore", ["questions"])
  },
  watch: {
    status(val) {
      if (val) {
        this.slectedChapter=null;
        if (
          this.questions &&
          this.questions.length &&
          this.questions[this.index]
        ) {
          this.selectedQuestion = this.questions[this.index];
          if (this.index === this.questions.length - 1) {
            this.selectedQuestion.btnText = "Done";
          } else {
            this.selectedQuestion.btnText = "Add Next Question";
          }
        }
      } else {
        this.index = 0;
        this.selectedQuestion = null;
      }
    }
  }
};
</script>